import React from 'react';
import c from '../w.js';

const IconTableSortDescending = React.memo(
  c(/* @__PURE__ */ React.createElement("path", { d: "M12.3529 15L6 9H18L12.3529 15Z" }))
);

export { IconTableSortDescending };
